import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Button, Form, Alert, FormFeedback } from 'reactstrap';
import { Loader } from '../../Layout';
import { Navigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import InputEmail from '../../FormElements/InputEmailControlled';

import { validateField } from '../../Validation/validateField';
import { validateFields } from '../../Validation/validateFields';
import RequiredRule from '../../Validation/ValidationRules/RequiredRule';
import EmailFormatRule from '../../Validation/ValidationRules/EmailFormatRule';
import ValidationErrors from '../../Validation/ValidationErrors';

import { withTranslator } from '../../I18n/withTranslator';
import { withMobileAppMode } from '../../Layout';
import { withToast } from '../../Toast';

export class AuthRemindPasswordComponent extends React.Component {
  static propTypes = {
    remindPassword: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    toastError: PropTypes.func.isRequired,
    toastSuccess: PropTypes.func.isRequired,
  };

  state = {
    emailVariable: '',
    email: '',
    preload: false,
    success: false,
    errors: new ValidationErrors(),
    validationServerErrors: null,
  };

  validationRules = {
    email: [
      new RequiredRule({ translator: this.props.t }),
      new EmailFormatRule({ translator: this.props.t }),
    ],
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    const frontEndErrors = validateFields(this.validationRules, this.state, this.props.t);

    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        details: frontEndErrors,
      },
    }));

    if (frontEndErrors.length === 0) {
      this.setState({ preload: true });

      try {
        const response = await this.props.remindPassword({
          email: this.state.email,
        });
        const { code, details } = response.data.auth.remindPassword;

        if (code === 200) {
          this.setState({
            emailVariable: this.state.email,
            email: '',
            errors: new ValidationErrors(),
            success: true,
            preload: false,
          });
        } else {
          for (let i = 0; i < details.length; i += 1) {
            const error = details[i];
            if (error.fieldName in this.validationRules) {
              this.setState({
                validationServerErrors: response.data.auth.remindPassword.details.flatMap(
                  (error) => {
                    return error.messages;
                  }
                ),
              });
              break;
            }
          }
          this.setState({
            success: false,
            preload: false,
          });
        }
      } catch (e) {
        this.props.toastError();
        this.setState({
          success: false,
          preload: false,
        });
        throw new Error(`Failed to remind password, got error: ${e}`);
      }
    }
  };

  handleInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
    this.validateInput(event.target.name, event.target.value);
    this.setState({ validationServerErrors: null });
  };

  validateInput = (field, value) => {
    if (this.validationRules[field]) {
      this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          details: validateField(field, value, this.validationRules[field], prevState),
        },
      }));
    }
  };

  render() {
    if (this.props.isLoggedIn) {
      return <Navigate to="/" />;
    }
    if (this.state.sendSuccess) {
      return <Navigate to="/auth/login" />;
    }

    return (
      <>
        <section className="bg-white">
          <Container className="text-center py-5">
            <Row className="align-items-center full-height">
              <Col xs="12" sm={{ size: 6, offset: 3 }}>
                <h1 className="title-medium semi-bold">
                  {this.props.t('auth/remind-password/title')}
                </h1>
                <p>{this.props.t('auth/remind-password/description')}</p>
                {this.state.success ? (
                  <Alert color="info">
                    {this.props.t('auth/remind-password/success-message')}{' '}
                    <strong>{this.state.emailVariable}</strong>
                  </Alert>
                ) : (
                  ''
                )}

                <Form
                  onSubmit={this.handleSubmit}
                  data-test="remind-password-form"
                  className="text-start"
                >
                  <InputEmail
                    label={this.props.t('email')}
                    name="email"
                    value={this.state.email}
                    errors={this.state.errors}
                    handleChange={this.handleInputChange}
                    validationRules={this.validationRules.email}
                    showAsterisk={false}
                    data-test="email-input"
                  />
                  <FormFeedback
                    className={
                      this.state.validationServerErrors ? 'd-block text-center mb-2 mt-4' : 'd-none'
                    }
                  >
                    {this.state.validationServerErrors
                      ? this.state.validationServerErrors.map((message, k) => (
                          <li key={k} style={{ listStyle: 'none' }}>
                            {message}
                          </li>
                        ))
                      : ''}
                  </FormFeedback>
                  <Button color="primary" data-test="remind-password-button" className="w-100">
                    {this.props.t('send')}
                  </Button>
                </Form>
                <br />
                <p className="small">
                  <Link to="/auth/login" data-test="login-link">
                    {this.props.t('auth/login/back-link-text')}
                  </Link>
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        {this.state.preload ? <Loader /> : ''}
      </>
    );
  }
}

export default withMobileAppMode(withTranslator(withToast(AuthRemindPasswordComponent)));
